import type { SearchCalendarEvent } from 'constants/searchCalendarEvents'

/** Washed fill so overlay ranges read as a suggestion, not a selected stay. */
export const CALENDAR_EVENT_OVERLAY_FILL = 'color-mix(in srgb, var(--event-overlay-color) 30%, transparent)'

export interface CalendarEventOverlayHit {
  id: string
  color: string
  icon: SearchCalendarEvent['icon']
  isStart: boolean
  isEnd: boolean
}

export function getCalendarEventOverlayForIsoDate(
  events: ReadonlyArray<Pick<SearchCalendarEvent, 'id' | 'startDate' | 'endDate' | 'color' | 'icon'>>,
  isoDate: string,
): CalendarEventOverlayHit | undefined {
  const event = events.find(candidate => candidate.startDate <= isoDate && candidate.endDate >= isoDate)
  if (!event) return undefined

  return {
    id: event.id,
    color: event.color,
    icon: event.icon,
    isStart: isoDate === event.startDate,
    isEnd: isoDate === event.endDate,
  }
}
